import React from 'react';
import { AttendanceAPIResponse } from '../../types/attendance.types';
import { CHART_COLOR_SCHEME } from './UserAttendanceChart';

interface UserAttendanceLegendProps {
  apiData: AttendanceAPIResponse;
  userColors: Array<{ key: number; color: string }>;
  selectedUsers: number[];
  onUserSelectionChange: (userId: number) => void;
}

export const UserAttendanceLegend: React.FC<UserAttendanceLegendProps> = ({
  apiData,
  userColors,
  selectedUsers,
  onUserSelectionChange,
}) => {
  if (!apiData?.users || !Array.isArray(apiData.users)) {
    return null;
  }

  return (
    <div className="flex-none w-1/4 pl-4 overflow-auto custom-scrollbar max-h-full">
      <div className="space-y-0.5">
        {apiData.users.map((user, index) => {
          const userColor =
            userColors?.find((item) => item.key === user.id)?.color ||
            CHART_COLOR_SCHEME[index % CHART_COLOR_SCHEME.length];
          const isSelected = selectedUsers.includes(user.id) || selectedUsers.length === 0;

          return (
            <div
              key={user.id}
              className="flex items-center text-xs cursor-pointer hover:bg-muted/50 py-0.5 px-1 rounded transition-colors"
              onClick={() => onUserSelectionChange(user.id)}
              title={user.name}
            >
              <div
                className="w-2 h-2 rounded-full mr-1.5 flex-shrink-0 transition-opacity"
                style={{
                  backgroundColor: userColor,
                  opacity: isSelected ? 1 : 0.3,
                }}
              ></div>
              <div className="flex-1 truncate max-w-full" style={{ opacity: isSelected ? 1 : 0.5 }}>
                {user.name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
